import { ArrowUpwardOutlined, InfoOutlined } from '@mui/icons-material';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Link,
  MenuItem,
  Select,
  Stack,
  Switch,
  Table,
  TableBody,
  TableContainer,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { useState } from 'react';
import { AiFillEdit } from 'react-icons/ai';
// Mui styled css
import styled from '@emotion/styled';

// styling
import { filter } from 'lodash';
import { StyledTableCell, StyledTableRow } from '../Global/Styling';
// import Label from '../../Label';
// import SearchNotFound from '../../SearchNotFound';
import { UserListHead } from '../../components/_dashboard/user';
import USERLIST from '../../_mocks_/user';

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

// Another Sorting table into tabbing area
const TABLE_HEAD2 = [
  { id: 'id', label: 'Target Table Column', alignRight: false },
  { id: 'type', label: 'Source File Column', alignRight: false }
];
// Another Sorting table into tabbing area

function UploadPolicyTable() {
  const Input = styled('input')({
    display: 'none'
  });
  // Menu list state at tabbing area
  const [changeList1, setChangeList1] = useState('EmailId');
  // Table Grid const define here
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10000);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;
  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);
  const isUserNotFound = filteredUsers.length === 0;
  // Table Grid const define end

  // Switch button on off
  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)'
      }
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#a6ce39'
        }
      }
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200
      })
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
      boxSizing: 'border-box'
    }
  }));
  // Switch button on off end

  return (
    <Box className="viewLeadCard">
      <Grid container>
        <Grid item sm={3}>
          <Box
            sx={{
              borderBottom: '1px solid #ccc',
              paddingTop: '0.5rem',
              paddingRight: '1rem',
              marginBottom: '1rem',
              minHeight: '54px'
            }}
          >
            <Grid container alignItems="center">
              <Grid item sm={7}>
                <Typography variant="body2">
                  <strong>File Name</strong>
                </Typography>
              </Grid>
              <Grid item sm={5} position="relative">
                <TextField
                  placeholder=""
                  defaultValue="homeloan"
                  inputProps={{ className: 'textInput textInputTable' }}
                  disabled
                />
                <IconButton className="" sx={{ position: 'absolute', right: '1px', top: '1px' }}>
                  <AiFillEdit size={14} />
                </IconButton>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ marginBottom: '1rem', display: 'flex', alignItems: 'center' }}>
            <Typography variant="body1">
              <strong>List of Fields</strong>
            </Typography>
            <ArrowUpwardOutlined sx={{ ml: 1 }} />
          </Box>
          <Stack spacing={2}>
            <Typography variant="body2">Country</Typography>
            <Typography variant="body2">Cutomer Banking ID</Typography>
            <Typography variant="body2">DOB</Typography>
            <Typography variant="body2">Email ID</Typography>
            <Typography variant="body2">Gender</Typography>
            <Typography variant="body2">Name</Typography>
          </Stack>
        </Grid>
        <Grid item sm={9}>
          <Box
            sx={{
              borderBottom: '1px solid #ccc',
              borderLeft: '1px solid #ccc',
              paddingTop: '2px',
              paddingLeft: '1rem',
              minHeight: '54px'
            }}
          >
            <Grid container alignItems="center">
              <Grid item xs>
                <Typography variant="body2">
                  <strong>Fields Mapping</strong>
                </Typography>
              </Grid>
              <Grid item xs textAlign="right">
                <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                  <AntSwitch
                    // defaultChecked
                    inputProps={{ 'aria-label': 'ant design' }}
                    sx={{ mr: 1 }}
                  />
                  <Typography
                    component="div"
                    sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}
                  >
                    Intelligent mapping
                  </Typography>
                </Box>
                <Typography component="div">
                  <Link to="#" className="f11">
                    What is this?
                  </Link>
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{ borderLeft: '1px solid #ccc', paddingLeft: '1rem', paddingTop: '1rem' }}
            className="gbleVTabInfo"
          >
            <Box>
              <Typography className="formLabel" mb={1}>
                Select Target Table
              </Typography>
              <Typography
                component="div"
                display="flex"
                alignItems="center"
                mb={2}
                sx={{ width: '300px' }}
              >
                <Select
                  fullWidth
                  inputProps={{
                    className: 'textInput'
                  }}
                  className="gbleInpt"
                  value={changeList1}
                  onChange={(e) => setChangeList1(e.target.value)}
                >
                  <MenuItem value="Address">Address</MenuItem>
                  <MenuItem value="City">City</MenuItem>
                  <MenuItem value="Country">Country</MenuItem>
                  <MenuItem value="CustomerBankingID">CustomerBankingID</MenuItem>
                  <MenuItem value="EmailId">Email Id</MenuItem>
                  <MenuItem value="Gender">Gender</MenuItem>
                  <MenuItem value="Individual">Individual</MenuItem>
                  <MenuItem value="Name">Name</MenuItem>
                  <MenuItem value="Phone">Phone</MenuItem>
                  <MenuItem value="SSN">SSN</MenuItem>
                  <MenuItem value="State">State</MenuItem>
                  <MenuItem value="Zip">Zip</MenuItem>
                </Select>
              </Typography>
              <Typography className="formLabel" mb={1}>
                Unique Key
              </Typography>
              <Typography
                component="div"
                display="flex"
                alignItems="center"
                mb={2}
                sx={{ width: '332px' }}
              >
                <TextField
                  fullWidth
                  inputProps={{
                    className: 'textInput'
                  }}
                  defaultValue="Email"
                  disabled
                />
                {/* <Select
                  fullWidth
                  inputProps={{
                    className: 'textInput'
                  }}
                  className="gbleInpt"
                  value={changeList1}
                  onChange={(e) => setChangeList1(e.target.value)}
                >
                  <MenuItem value="Address">Address</MenuItem>
                  <MenuItem value="City">City</MenuItem>
                  <MenuItem value="Country">Country</MenuItem>
                  <MenuItem value="CustomerBankingID">CustomerBankingID</MenuItem>
                  <MenuItem value="EmailId">Email Id</MenuItem>
                  <MenuItem value="Gender">Gender</MenuItem>
                  <MenuItem value="Individual">Individual</MenuItem>
                  <MenuItem value="Name">Name</MenuItem>
                  <MenuItem value="Phone">Phone</MenuItem>
                  <MenuItem value="SSN">SSN</MenuItem>
                  <MenuItem value="State">State</MenuItem>
                  <MenuItem value="Zip">Zip</MenuItem>
                </Select> */}
                <Tooltip
                  title={
                    <Box p={2}>
                      <Typography color="inherit" component="div" mb={1}>
                        <b>Don’t see your primary key?</b>
                      </Typography>
                      <Typography className="f12" sx={{ fontWeight: 'normal' }}>
                        Only string, GUID, and integer data types are supported.
                      </Typography>
                    </Box>
                  }
                  placement="right"
                  arrow
                >
                  <InfoOutlined className="fntdarkBlue" sx={{ ml: 1, cursor: 'pointer' }} />
                </Tooltip>
              </Typography>
              <Typography component="div" mb={1} fontWeight="normal" sx={{ color: '#222' }}>
                Review mapped fields
              </Typography>
              <TableContainer sx={{ marginBottom: '1rem' }}>
                <Table border={1} borderColor="#ebedf2">
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD2}
                    rowCount={USERLIST.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    <StyledTableRow
                      hover
                      // key={id}
                      tabIndex={-1}
                      role="checkbox"
                      // selected={isItemSelected}
                      // aria-checked={isItemSelected}
                    >
                      <StyledTableCell>Country</StyledTableCell>
                      <StyledTableCell>
                        <Select
                          inputProps={{
                            className: 'textInput textInputTable'
                          }}
                          className="gbleInpt"
                          // value="Calendar.Date"
                          defaultValue="Calendar.Date"
                          sx={{ width: '300px !important' }}
                          // onChange={(e) => setChangeList2(e.target.value)}
                        >
                          <MenuItem value="Account">Account</MenuItem>
                          <MenuItem value="BarCode">BarCode</MenuItem>
                          <MenuItem value="Brand">Brand</MenuItem>
                          <MenuItem value="Calendar.Date">Calendar.Date</MenuItem>
                        </Select>
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      // key={id}
                      tabIndex={-1}
                      role="checkbox"
                      // selected={isItemSelected}
                      // aria-checked={isItemSelected}
                    >
                      <StyledTableCell>CustomerBankingID</StyledTableCell>
                      <StyledTableCell>
                        <Select
                          inputProps={{
                            className: 'textInput textInputTable'
                          }}
                          className="gbleInpt"
                          // value="Calendar.Date"
                          defaultValue="ID"
                          sx={{ width: '300px !important' }}
                          // onChange={(e) => setChangeList2(e.target.value)}
                        >
                          <MenuItem value="Account">Account</MenuItem>
                          <MenuItem value="BarCode">BarCode</MenuItem>
                          <MenuItem value="Brand">Brand</MenuItem>
                          <MenuItem value="ID">ID</MenuItem>
                        </Select>
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      // key={id}
                      tabIndex={-1}
                      role="checkbox"
                      // selected={isItemSelected}
                      // aria-checked={isItemSelected}
                    >
                      <StyledTableCell>DOB</StyledTableCell>
                      <StyledTableCell>
                        <Select
                          inputProps={{
                            className: 'textInput textInputTable'
                          }}
                          className="gbleInpt"
                          // value="Calendar.Date"
                          defaultValue="Person.BirthDate"
                          sx={{ width: '300px !important' }}
                          // onChange={(e) => setChangeList2(e.target.value)}
                        >
                          <MenuItem value="Account">Account</MenuItem>
                          <MenuItem value="BarCode">BarCode</MenuItem>
                          <MenuItem value="Brand">Brand</MenuItem>
                          <MenuItem value="Person.BirthDate">Person.BirthDate</MenuItem>
                        </Select>
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      // key={id}
                      tabIndex={-1}
                      role="checkbox"
                      // selected={isItemSelected}
                      // aria-checked={isItemSelected}
                    >
                      <StyledTableCell>EmailId</StyledTableCell>
                      <StyledTableCell>
                        <Select
                          inputProps={{
                            className: 'textInput textInputTable'
                          }}
                          className="gbleInpt"
                          // value="Calendar.Date"
                          defaultValue="Identity.Service.Email"
                          sx={{ width: '300px !important' }}
                          // onChange={(e) => setChangeList2(e.target.value)}
                        >
                          <MenuItem value="Account">Account</MenuItem>
                          <MenuItem value="BarCode">BarCode</MenuItem>
                          <MenuItem value="Brand">Brand</MenuItem>
                          <MenuItem value="Identity.Service.Email">Identity.Service.Email</MenuItem>
                        </Select>
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      // key={id}
                      tabIndex={-1}
                      role="checkbox"
                      // selected={isItemSelected}
                      // aria-checked={isItemSelected}
                    >
                      <StyledTableCell>Gender</StyledTableCell>
                      <StyledTableCell>
                        <Select
                          inputProps={{
                            className: 'textInput textInputTable'
                          }}
                          className="gbleInpt"
                          // value="Calendar.Date"
                          defaultValue="Person.Gender"
                          sx={{ width: '300px !important' }}
                          // onChange={(e) => setChangeList2(e.target.value)}
                        >
                          <MenuItem value="Account">Account</MenuItem>
                          <MenuItem value="BarCode">BarCode</MenuItem>
                          <MenuItem value="Brand">Brand</MenuItem>
                          <MenuItem value="Person.Gender">Person.Gender</MenuItem>
                        </Select>
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      // key={id}
                      tabIndex={-1}
                      role="checkbox"
                      // selected={isItemSelected}
                      // aria-checked={isItemSelected}
                    >
                      <StyledTableCell>Name</StyledTableCell>
                      <StyledTableCell>
                        <Select
                          inputProps={{
                            className: 'textInput textInputTable'
                          }}
                          className="gbleInpt"
                          // value="Calendar.Date"
                          defaultValue="Person.FullName"
                          sx={{ width: '300px !important' }}
                          // onChange={(e) => setChangeList2(e.target.value)}
                        >
                          <MenuItem value="Account">Account</MenuItem>
                          <MenuItem value="BarCode">BarCode</MenuItem>
                          <MenuItem value="Brand">Brand</MenuItem>
                          <MenuItem value="Person.FullName">Person.FullName</MenuItem>
                        </Select>
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      // key={id}
                      tabIndex={-1}
                      role="checkbox"
                      // selected={isItemSelected}
                      // aria-checked={isItemSelected}
                    >
                      <StyledTableCell>Phone</StyledTableCell>
                      <StyledTableCell>
                        <Select
                          inputProps={{
                            className: 'textInput textInputTable'
                          }}
                          className="gbleInpt"
                          // value="Calendar.Date"
                          defaultValue="Identity.Service.Phone"
                          sx={{ width: '300px !important' }}
                          // onChange={(e) => setChangeList2(e.target.value)}
                        >
                          <MenuItem value="Account">Account</MenuItem>
                          <MenuItem value="BarCode">BarCode</MenuItem>
                          <MenuItem value="Brand">Brand</MenuItem>
                          <MenuItem value="Identity.Service.Phone">Identity.Service.Phone</MenuItem>
                        </Select>
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      // key={id}
                      tabIndex={-1}
                      role="checkbox"
                      // selected={isItemSelected}
                      // aria-checked={isItemSelected}
                    >
                      <StyledTableCell>SSN</StyledTableCell>
                      <StyledTableCell>
                        <Select
                          inputProps={{
                            className: 'textInput textInputTable'
                          }}
                          className="gbleInpt"
                          // value="Calendar.Date"
                          defaultValue="Identitiy.Government.ID"
                          sx={{ width: '300px !important' }}
                          // onChange={(e) => setChangeList2(e.target.value)}
                        >
                          <MenuItem value="Account">Account</MenuItem>
                          <MenuItem value="BarCode">BarCode</MenuItem>
                          <MenuItem value="Brand">Brand</MenuItem>
                          <MenuItem value="Identitiy.Government.ID">
                            Identitiy.Government.ID
                          </MenuItem>
                        </Select>
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      // key={id}
                      tabIndex={-1}
                      role="checkbox"
                      // selected={isItemSelected}
                      // aria-checked={isItemSelected}
                    >
                      <StyledTableCell>SSN</StyledTableCell>
                      <StyledTableCell>
                        <Select
                          inputProps={{
                            className: 'textInput textInputTable'
                          }}
                          className="gbleInpt"
                          // value="Calendar.Date"
                          defaultValue="Location.State"
                          sx={{ width: '300px !important' }}
                          // onChange={(e) => setChangeList2(e.target.value)}
                        >
                          <MenuItem value="Account">Account</MenuItem>
                          <MenuItem value="BarCode">BarCode</MenuItem>
                          <MenuItem value="Brand">Brand</MenuItem>
                          <MenuItem value="Location.State">Location.State</MenuItem>
                        </Select>
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      // key={id}
                      tabIndex={-1}
                      role="checkbox"
                      // selected={isItemSelected}
                      // aria-checked={isItemSelected}
                    >
                      <StyledTableCell>Zip</StyledTableCell>
                      <StyledTableCell>
                        <Select
                          inputProps={{
                            className: 'textInput textInputTable'
                          }}
                          className="gbleInpt"
                          // value="Calendar.Date"
                          defaultValue="Location.PostalCode"
                          sx={{ width: '300px !important' }}
                          // onChange={(e) => setChangeList2(e.target.value)}
                        >
                          <MenuItem value="Account">Account</MenuItem>
                          <MenuItem value="BarCode">BarCode</MenuItem>
                          <MenuItem value="Brand">Brand</MenuItem>
                          <MenuItem value="Location.PostalCode">Location.PostalCode</MenuItem>
                        </Select>
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <Box mb={2}>
                <FormControlLabel
                  control={<Checkbox size="small" />}
                  label="Delete Duplicate Data"
                />
              </Box>
              <Box>
                <Button className="mainBtn mainBtnOther mainBtnSec">validate</Button>
                <Button className="mainBtn mainBtnOther mainBtnSec ml-2">Insert</Button>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
export default UploadPolicyTable;
